import type { ReactNode } from 'react';

export function Panel({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        background: 'var(--surface-2)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-lg)',
        padding: '20px',
      }}
    >
      {children}
    </div>
  );
}
